const addYears = (date, years) => {
  date.setFullYear(date.getFullYear() + years);
  return date;
};

export { addYears };
